export default "__VITE_ASSET__cNfvBYZP__"